import axios from "axios";

// 🔑 Axios instance


const API = axios.create({
  baseURL: "https://dsa-buddy-back.vercel.app/api"
});





// ✅ Token ko request ke sath bhejna
API.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");
  if (token) {
    req.headers.Authorization = `Bearer ${token}`;
  }
  return req;
});

/* ---------------- AUTH APIs ---------------- */
export const registerUser = (data) => API.post("/auth/register", data);
export const verifyOtp = (data) => API.post("/auth/verify-otp", data);
export const resendOtp = (data) => API.post("/auth/resend-otp", data);
export const loginUser = (data) => API.post("/auth/login", data);
export const resetPassword = (data) => API.post("/auth/reset-password", data);
export const getUserDetails = (id) => API.get(`/auth/user/${id}`);
export const updateUser = (data) => API.put("/auth/user/update", data);
export const deleteAccount = () => API.delete("/auth/user/delete");
export const logoutUser = () => API.post("/auth/logout");

export const getAllQuestionsForUser = () => API.get("/auth/questions");
// export const solveQuestionWithAI = () => API.get("/auth/questions");



/* ---------------- ADMIN APIs ---------------- */
export const addQuestion = (data) => API.post("/admin/add-question", data);
export const getAllUsersAdmin = () => API.get("/admin/users");
export const deleteUser = (id) => API.delete(`/admin/user/${id}`);
export const getCurrentUser = () => API.get("/auth/me");


/* ---------------- AI APIs ---------------- */
export const solveQuestionWithAI = (data) => API.post("/ai/solve", data);
export const getSearchSuggestions = (data) => API.post("/ai/search-suggestions", data);


// ✅ Create Razorpay Order
export const createOrder = ({ amount, currency }) =>
  API.post("/payment/order", { amount, currency });

// ✅ Verify Razorpay Payment
export const verifyPayment = (paymentData) =>
  API.post("/payment/verify", paymentData);

export const getTransactionHistory = () =>
  API.get("/payment/history");


export const getPremiumQuestions = () => API.get("/admin/primium");

export default API;





